<template>
    <div class="moderation page-container">
        <div class="content-container">
            <img class="img-content-top" src="../assets/Logo-menschen.png">
            <div class="content-text">
                <div>
                    <h1 class="header">{{ page.title }}</h1>
                    <p> {{ page.text }} </p>
                </div>
            </div>
            <img class="img-content-bottom" src="../assets/Logo-menschen.png">
        </div>
        <div class="home-content" v-bind:class="{ slidedown: textSlideDown }">
            <h1 class="header">{{ page.title }}</h1>
            <p v-if="page.subtitle !== false" class="subtitle">{{ page.subtitle }}</p>
            <p> {{ page.text }} </p>
        </div>
        <div class="home-content-mobile">
            <div>
                <div>
                    <img src="../assets/Logo-menschen.png">
                </div>
                <div>
                    <h1 class="header">{{ page.title }}</h1>
                    <p v-if="page.subtitle !== false" class="subtitle">{{ page.subtitle }}</p>
                    <p> {{ page.text }} </p>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import home from '../content/home.json'

    export default {
        metaInfo: {
            title: "Home",
            titleTemplate: "%s | DrThumm GmbH",
            meta: [
                { name: 'description', content: "HOME" }
            ]
        },
        data() {
            return {
                content: {
                    home
                },
                showHome: false,
                showLandingpage: true,
            }
        },
        computed: {
            page() {
                this.showImage = false
                let content = this.content
                let route = this.$route.fullPath
                if (route !== "/") {
                    let routes = route.split('/')
                    var filtered = routes.filter(el => el != "")

                    filtered.forEach(r => {
                        if (filtered.length === 1) content = content[r][r]
                        else content = content[r]
                    })
                } else content = content['home']['page']

                if (!this.landingview) this.textSlideDown = true

                return content
            },
            textSlideDown() {
                return !this.$store.state.isLandingView
            }
        },

        mounted() {
            if (localStorage.getItem('showLandingpage') !== undefined && localStorage.getItem('showLandingpage') === 'false') {
                this.showLandingpage = false
                this.showHome = true
            }

            if (!this.showLandingpage) {
                this.textSlideDown = true
            }

        },
        beforeCreate() {
            document.body.className = "home-page"

        }
    }
</script>
<style lang="sass" scoped>


    .img-content-bottom
        display: block

    .img-content-top
        display: none


    .content-container
        display: none

        p, h1
            color: #fff

        .content-text > div
            padding-right: 40px
            padding-left: 0

    .home-content
        width: 35%
        margin-left: -10%
        color: #fff

    .home-content-mobile
        display: none
        color: #fff
        width: 90%
        margin: 50px auto
        flex-direction: column
        text-align: center

        img
            max-width: 100%
            width: 80%
            max-width: 400px
            margin: 0 auto

    .home-content
        opacity: 0

    @media (max-width: 1300px) and (min-width: 1051px)
        .home-content
            margin-left: 5%


    @media (max-width: 1700px) and (min-width: 1301px)
        .home-content
            margin-left: 0%

    @media (max-width: 1050px) and (min-width: 900px) and (max-height: 700px)
        .home-content
            width: 30%
            margin-left: 5%


    @media (max-width: 900px)
        .home-content
            display: none

        .img-content-bottom
            display: none

        .img-content-top
            display: block

        .home-content-mobile
            display: none

        .content-container
            display: flex
            flex-direction: column

            .content-text > div
                padding: 0


    @media (min-width: 900px) and (max-aspect-ratio: 3/2)
        .home-content
            display: none

        .home-content-mobile
            display: none


        .content-container
            display: flex




</style>